export var BankslipResponseStatus;
(function (BankslipResponseStatus) {
    BankslipResponseStatus[BankslipResponseStatus["PENDING"] = 1] = "PENDING";
    BankslipResponseStatus[BankslipResponseStatus["PAID"] = 2] = "PAID";
    BankslipResponseStatus[BankslipResponseStatus["OVERDUE"] = 3] = "OVERDUE";
    BankslipResponseStatus[BankslipResponseStatus["EXPIRED"] = 4] = "EXPIRED";
    BankslipResponseStatus[BankslipResponseStatus["CREATING"] = 5] = "CREATING";
    BankslipResponseStatus[BankslipResponseStatus["ERROR"] = 6] = "ERROR";
    BankslipResponseStatus[BankslipResponseStatus["PENDING_PAYER_CREATE"] = 7] = "PENDING_PAYER_CREATE";
    BankslipResponseStatus[BankslipResponseStatus["PENDING_PAYMENT"] = 8] = "PENDING_PAYMENT";
    BankslipResponseStatus[BankslipResponseStatus["CANCELLED"] = 9] = "CANCELLED";
})(BankslipResponseStatus || (BankslipResponseStatus = {}));
export * from './limits';
